<div class="modal">
  <div class="modal-content"
    [ngClass]="size"
    [class.bg]="!options?.noBg"
    [class.small-header]="options?.headerHeight === 'small'"
    [class.small-rounded]="options?.rounded === 'small'">
    <ng-template #modalContainer></ng-template>
  </div>
</div>
